<div class="hub-page-wrapper" data-testid="stepper-page">
  <ng-content> </ng-content>
</div>
